// src/components/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnitSelector from './UnitSelector';
import LogoutButton from './LogoutButton';
import './Header_log.css';
import header from '../assets/header.png';

function Header({ selectedUnit, handleUnitChange, handleLogout, showUnitSelector = true }) {
  const navigate = useNavigate();

  const shortcuts = [
    { label: 'Painel', onClick: () => navigate('/admin'), variant: 'primary' },
    { label: 'Auditoria', onClick: () => navigate('/auditoria'), variant: 'ghost' },
    { label: 'Resultados 2024', onClick: () => navigate('/painel/2024'), variant: 'ghost' },
    { label: 'Resultados 2026', onClick: () => navigate('/painel/2026'), variant: 'ghost' },
    { label: 'Escolher Ano', onClick: () => navigate('/year-selection'), variant: 'ghost' },
    { label: 'Importar CSV', onClick: () => navigate('/admin#import'), variant: 'ghost' }
  ];

  return (
    <header className="app-header">
      <div className="app-header__bar">
        <div className="app-header__brand" onClick={() => navigate('/')}>
          <div className="app-header__logo">ID</div>
          <div className="app-header__titles">
            <span className="app-header__title">Painel IDECACE</span>
            <span className="app-header__subtitle">Pesquisa de satisfação • 2024–2026</span>
          </div>
        </div>

        <div className="app-header__controls">
          {showUnitSelector && handleUnitChange && (
            <div className="app-header__unit">
              <UnitSelector selectedUnit={selectedUnit} handleUnitChange={handleUnitChange} />
            </div>
          )}
          <div className="app-header__shortcuts">
            {shortcuts.map((btn) => (
              <button
                key={btn.label}
                className={`chip-btn ${btn.variant}`}
                onClick={btn.onClick}
              >
                {btn.label}
              </button>
            ))}
          </div>
          <LogoutButton handleLogout={handleLogout} />
        </div>
      </div>

      <div className="app-header__hero">
        <div>
          <h1 className="app-header__heading">Relatório de Pesquisa de Satisfação</h1>
          <p className="app-header__lede">Acompanhe envios, respostas e auditorias em um só lugar.</p>
        </div>
        <div className="app-header__art">
          <img src={header} alt="Ilustração de família" className="imgheader" />
        </div>
      </div>
    </header>
  );
}

export default Header;
